/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminHomeBanner } from '../models/AdminHomeBanner';
import type { Body_create_home_banner_api_v1_admin_home_banners_post } from '../models/Body_create_home_banner_api_v1_admin_home_banners_post';
import type { Body_update_home_banner_api_v1_admin_home_banners__banner_id__put } from '../models/Body_update_home_banner_api_v1_admin_home_banners__banner_id__put';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminHomeBannersService {

    /**
     * List Admin Home Banners
     * Every banner, whether scheduled, live, or over. Latest start first.
     * @returns AdminHomeBanner Successful Response
     * @throws ApiError
     */
    public static listAdminHomeBannersApiV1AdminHomeBannersGet(): CancelablePromise<Array<AdminHomeBanner>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/home-banners',
        });
    }

    /**
     * Create Home Banner
     * @param formData
     * @returns AdminHomeBanner Successful Response
     * @throws ApiError
     */
    public static createHomeBannerApiV1AdminHomeBannersPost(
        formData: Body_create_home_banner_api_v1_admin_home_banners_post,
    ): CancelablePromise<AdminHomeBanner> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/home-banners',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Admin Home Banner
     * One banner, whatever its schedule. For previews and the edit form.
     * @param bannerId
     * @returns AdminHomeBanner Successful Response
     * @throws ApiError
     */
    public static getAdminHomeBannerApiV1AdminHomeBannersBannerIdGet(
        bannerId: string,
    ): CancelablePromise<AdminHomeBanner> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/home-banners/{banner_id}',
            path: {
                'banner_id': bannerId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Home Banner
     * Replace every field, including on a live banner. Viewers see it on their next page load.
     *
     * Images are kept unless a new file or a ``remove_*`` flag is sent.
     * @param bannerId
     * @param formData
     * @returns AdminHomeBanner Successful Response
     * @throws ApiError
     */
    public static updateHomeBannerApiV1AdminHomeBannersBannerIdPut(
        bannerId: string,
        formData: Body_update_home_banner_api_v1_admin_home_banners__banner_id__put,
    ): CancelablePromise<AdminHomeBanner> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/home-banners/{banner_id}',
            path: {
                'banner_id': bannerId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
